<template>
  <div class="project-view-wrapper">
    <loading-spinner v-if="isLoading" text="กำลังโหลดโครงการ..." />
    <template v-else>
      <project-page-header />
      <div class="project-content-wrapper">
        <sub-nav-sidebar v-if="isSubNavEnabled" />
        <div
          class="project-content"
          :style="{
            paddingLeft: isSubNavEnabled ? '240px' : 0,
            paddingTop: hasActionBar ? '158px' : '105px'
          }"
        >
          <action-bar v-if="hasActionBar" :sub-nav-offset="isSubNavEnabled ? 240 : 0" />
          <router-view />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Wormhole } from 'portal-vue'
import ActionBar from '@/components/project/ActionBar'
import LoadingSpinner from '@/components/layouts/LoadingSpinner'
import SubNavSidebar from '@/components/project/SubNavSidebar'
import ProjectPageHeader from '@/components/project/ProjectPageHeader'

export default {
  components: { ActionBar, LoadingSpinner, SubNavSidebar, ProjectPageHeader },
  computed: {
    isLoading () { return this.$store.state.loadingStates.project },
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) },
    isSubNavEnabled () {
      return true
      // return this.project.status === 'Approved' || this.project.status === 'AwaitingForClosureApproval' || this.project.status === 'Closed'
    },
    hasActionBar () {
      return Wormhole.hasContentFor('project-action-bar') || this.project.action.length
    }
  }
}
</script>

<style lang="scss" scoped>
.project-view-wrapper {
  min-height: calc(100vh - 46px);
}

.project-content {
  position: relative;
  min-height: calc(100vh - 46px);
}
</style>
